// import React, { useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useAuth } from "../../Common/Configurations/AuthContext";
// import config from "../../Common/Configurations/APIConfig";
// import apiService from "../../Common/Configurations/APIService";
// import Header from "../../Common/Layout/Header";
// import {
//   RiArrowLeftLine,
//   RiMoneyRupeeCircleLine,
//   RiCheckboxCircleLine,
//   RiErrorWarningLine,
//   RiTimeLine,
//   RiShieldLine,
//   RiLockUnlockLine,
//   RiBusLine,
//   RiMapPinLine,
//   RiUserLine,
//   RiCalendarLine,
// } from "react-icons/ri";

// const CompletePayment = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { user } = useAuth();

//   const {
//     bookingId,
//     bookingNo,
//     bookTicketKey,
//     bus,
//     searchQuery,
//     selectedSeats = [],
//     passengerCount = 0,
//     passengerDetails = [],
//     selectedBoardingPoint,
//     selectedDroppingPoint,
//     totalAmount = 0,
//     baseFare = 0,
//     convenienceFee = 0,
//   } = location.state || {};

//   const [isProcessing, setIsProcessing] = useState(false);
//   const [paymentMethod, setPaymentMethod] = useState("RAZORPAY");

//   // Redirect if no booking data
//   if (!bookingId || !bookTicketKey) {
//     navigate("/bus/blocked-bookings");
//     return null;
//   }

//   const formatCurrency = (amount) => {
//     const num = parseFloat(amount) || 0;
//     return `₹${Math.round(num).toLocaleString("en-IN")}`;
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     try {
//       const date = new Date(dateString);
//       const day = date.getDate().toString().padStart(2, "0");
//       const monthNames = [
//         "Jan",
//         "Feb",
//         "Mar",
//         "Apr",
//         "May",
//         "Jun",
//         "Jul",
//         "Aug",
//         "Sep",
//         "Oct",
//         "Nov",
//         "Dec",
//       ];
//       const month = monthNames[date.getMonth()];
//       const year = date.getFullYear();
//       return `${day}-${month}-${year}`;
//     } catch (error) {
//       return dateString;
//     }
//   };

//   const handlePayment = async () => {
//     setIsProcessing(true);

//     try {
//       // Load Razorpay script
//       const res = await loadRazorpayScript();
//       if (!res) {
//         alert("Razorpay SDK failed to load. Are you online?");
//         return;
//       }

//       // Create payment order
//       const paymentResult = await apiService.post(
//         `${config.MAKEPAYMENT}?Amount=${totalAmount}&PayRequest=${paymentMethod}&CompanyId=${user?.cid}`
//       );

//       if (!paymentResult.succeeded) {
//         alert("Payment initiation failed. Please try again.");
//         return;
//       }

//       const { id: order_id, currency, razorpayKey, name } = paymentResult.data;

//       const options = {
//         key: razorpayKey,
//         amount: totalAmount * 100,
//         currency: currency,
//         name: name,
//         description: `Complete Blocked Booking - ${bus?.operatorName}`,
//         order_id: order_id,
//         handler: async function (paymentResponse) {
//           try {
//             // Call BlockAndBook API to confirm blocked booking
//             const confirmResponse = await apiService.post(
//               config.CONFIRMBLOCKEDBOOKING,
//               {
//                 blockTicketKey: bookTicketKey,
//                 paymentResponse: paymentResponse,
//                 CompanyId: user?.cid,
//                 UserId: user?.id,
//                 PaymentStatus: "SUCCESS",
//                 PaymentGateway: paymentMethod,
//               }
//             );

//             if (confirmResponse && confirmResponse.apiStatus?.success) {
//               // Navigate to confirmation
//               navigate("/bus/booking-confirmation", {
//                 state: {
//                   bookingStatus: "CONFIRMED",
//                   bookingId: confirmResponse.bookingId,
//                   bookingNo: confirmResponse.bookingNo,
//                   pnr: confirmResponse.pnr,
//                   supplierBookingId: confirmResponse.supplierBookingId,
//                   invoiceNo: confirmResponse.invoiceNo,
//                   bookTicketKey: confirmResponse.bookTicketKey,
//                   saleInvoiceNumber: confirmResponse.saleInvoiceNumber,
//                   purchaseInvoiceNumber: confirmResponse.purchaseInvoiceNumber,
//                   paymentId: paymentResponse.razorpay_payment_id,
//                   orderId: paymentResponse.razorpay_order_id,
//                   message: "Booking confirmed successfully!",
//                   bus,
//                   searchQuery,
//                   selectedSeats,
//                   passengerCount,
//                   passengerDetails,
//                   selectedBoardingPoint,
//                   selectedDroppingPoint,
//                   totalAmount,
//                   baseFare,
//                   convenienceFee,
//                 },
//               });
//             } else {
//               alert(
//                 `Confirmation failed: ${confirmResponse?.apiStatus?.message}`
//               );
//               setIsProcessing(false);
//             }
//           } catch (error) {
//             console.error("Confirmation error:", error);
//             alert("Confirmation failed. Please contact support.");
//             setIsProcessing(false);
//           }
//         },
//         prefill: {
//           email: user?.email,
//           contact: user?.phoneNumber,
//           name: user?.name,
//         },
//         theme: {
//           color: "#3399cc",
//         },
//       };

//       const paymentObject = new window.Razorpay(options);

//       paymentObject.on("payment.failed", function (response) {
//         console.error("Payment failed:", response.error);
//         setIsProcessing(false);
//         alert(`Payment failed: ${response.error.description}`);
//       });

//       paymentObject.on("payment.cancel", function (response) {
//         console.log("Payment cancelled by user:", response);
//         setIsProcessing(false);
//         alert("Payment was cancelled.");
//       });

//       paymentObject.open();
//     } catch (error) {
//       console.error("Payment error:", error);
//       alert("Payment initiation failed. Please try again.");
//       setIsProcessing(false);
//     }
//   };

//   const loadRazorpayScript = () => {
//     return new Promise((resolve) => {
//       if (window.Razorpay) {
//         resolve(true);
//         return;
//       }

//       const script = document.createElement("script");
//       script.src = "https://checkout.razorpay.com/v1/checkout.js";
//       script.onload = () => resolve(true);
//       script.onerror = () => resolve(false);
//       document.body.appendChild(script);
//     });
//   };

//   const handleBack = () => {
//     navigate("/bus/blocked-bookings");
//   };

//   return (
//     <div id="layout-wrapper">
//       <Header />

//       <div className="main-content">
//         <div className="page-content">
//           <div className="container-fluid">
//             {/* Page Header */}
//             <div className="row mb-4">
//               <div className="col-12">
//                 <div className="d-flex justify-content-between align-items-center">
//                   <div>
//                     <h3 className="mb-1">Complete Payment</h3>
//                     <p className="text-muted mb-0">
//                       Confirm your blocked seats by completing payment
//                     </p>
//                   </div>
//                   <button
//                     className="btn btn-outline-secondary"
//                     onClick={handleBack}
//                   >
//                     <RiArrowLeftLine className="me-1" />
//                     Back
//                   </button>
//                 </div>
//               </div>
//             </div>

//             <div className="row">
//               {/* Left Column - Booking Details */}
//               <div className="col-lg-8">
//                 {/* Booking Info Card */}
//                 <div className="card border-warning mb-4">
//                   <div className="card-header bg-warning text-white">
//                     <h5 className="mb-0">
//                       <RiTimeLine className="me-2" />
//                       Blocked Booking Details
//                     </h5>
//                   </div>
//                   <div className="card-body">
//                     <div className="alert alert-info">
//                       <RiShieldLine className="me-2" />
//                       <strong>Block Ticket Key:</strong> {bookTicketKey}
//                     </div>

//                     <div className="row">
//                       <div className="col-md-6">
//                         <div className="info-item mb-3">
//                           <RiBusLine className="text-muted me-2" />
//                           <div>
//                             <small className="text-muted">Route</small>
//                             <p className="mb-0 fw-semibold">
//                               {bus?.sourceCity} → {bus?.destinationCity}
//                             </p>
//                           </div>
//                         </div>
//                         <div className="info-item mb-3">
//                           <RiCalendarLine className="text-muted me-2" />
//                           <div>
//                             <small className="text-muted">Travel Date</small>
//                             <p className="mb-0 fw-semibold">
//                               {formatDate(searchQuery?.travelDate)}
//                             </p>
//                           </div>
//                         </div>
//                         <div className="info-item">
//                           <RiUserLine className="text-muted me-2" />
//                           <div>
//                             <small className="text-muted">Passengers</small>
//                             <p className="mb-0 fw-semibold">
//                               {passengerCount} Passenger(s)
//                             </p>
//                           </div>
//                         </div>
//                       </div>

//                       <div className="col-md-6">
//                         <div className="info-item mb-3">
//                           <RiMapPinLine className="text-muted me-2" />
//                           <div>
//                             <small className="text-muted">Operator</small>
//                             <p className="mb-0 fw-semibold">
//                               {bus?.operatorName}
//                             </p>
//                           </div>
//                         </div>
//                         <div className="info-item mb-3">
//                           <RiMapPinLine className="text-muted me-2" />
//                           <div>
//                             <small className="text-muted">Bus Type</small>
//                             <p className="mb-0 fw-semibold">
//                               {bus?.busType || "Standard"}
//                             </p>
//                           </div>
//                         </div>
//                         <div className="info-item">
//                           <div>
//                             <small className="text-muted">
//                               Booking Reference
//                             </small>
//                             <p className="mb-0 fw-semibold">{bookingNo}</p>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Time Warning */}
//                     <div className="alert alert-warning mt-3">
//                       <RiTimeLine className="me-2" />
//                       <strong>Time Sensitive:</strong> Complete payment to
//                       confirm your seats. Blocked seats will be released if not
//                       confirmed.
//                     </div>
//                   </div>
//                 </div>

//                 {/* Boarding Points */}
//                 {(selectedBoardingPoint || selectedDroppingPoint) && (
//                   <div className="card mb-4">
//                     <div className="card-header bg-light">
//                       <h5 className="mb-0">Boarding & Dropping Points</h5>
//                     </div>
//                     <div className="card-body">
//                       <div className="row">
//                         {selectedBoardingPoint && (
//                           <div className="col-md-6">
//                             <div className="point-details">
//                               <h6 className="text-primary">Boarding Point</h6>
//                               <p className="mb-1">
//                                 <strong>
//                                   {selectedBoardingPoint.location}
//                                 </strong>
//                               </p>
//                               <p className="text-muted mb-0">
//                                 Time: {selectedBoardingPoint.time}
//                               </p>
//                             </div>
//                           </div>
//                         )}
//                         {selectedDroppingPoint && (
//                           <div className="col-md-6">
//                             <div className="point-details">
//                               <h6 className="text-success">Dropping Point</h6>
//                               <p className="mb-1">
//                                 <strong>
//                                   {selectedDroppingPoint.location}
//                                 </strong>
//                               </p>
//                               <p className="text-muted mb-0">
//                                 Time: {selectedDroppingPoint.time}
//                               </p>
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>

//               {/* Right Column - Payment */}
//               <div className="col-lg-4">
//                 <div className="sticky-top" style={{ top: "20px" }}>
//                   {/* Payment Card */}
//                   <div className="card border-success">
//                     <div className="card-header bg-success text-white">
//                       <h5 className="mb-0">
//                         <RiLockUnlockLine className="me-2" />
//                         Complete Payment
//                       </h5>
//                     </div>
//                     <div className="card-body">
//                       {/* Amount Summary */}
//                       <div className="amount-summary mb-4">
//                         <div className="d-flex justify-content-between mb-2">
//                           <div>
//                             <span>Bus Fare</span>
//                             <small className="text-muted d-block">
//                               Includes all taxes
//                             </small>
//                           </div>
//                           <span>{formatCurrency(baseFare)}</span>
//                         </div>

//                         <div className="d-flex justify-content-between mb-2">
//                           <div>
//                             <span>Convenience Fee</span>
//                             <small className="text-muted d-block">
//                               ₹100 per seat
//                             </small>
//                           </div>
//                           <span>{formatCurrency(convenienceFee)}</span>
//                         </div>

//                         <hr />

//                         <div className="d-flex justify-content-between">
//                           <strong>Total Amount</strong>
//                           <strong className="text-success fs-5">
//                             {formatCurrency(totalAmount)}
//                           </strong>
//                         </div>
//                       </div>

//                       {/* Payment Method */}
//                       <div className="mb-4">
//                         <label className="form-label">Payment Method</label>
//                         <select
//                           className="form-select"
//                           value={paymentMethod}
//                           onChange={(e) => setPaymentMethod(e.target.value)}
//                         >
//                           <option value="RAZORPAY">
//                             Razorpay (Cards, UPI, Net Banking)
//                           </option>
//                           <option value="WALLET">Wallet Balance</option>
//                         </select>
//                       </div>

//                       {/* Action Button */}
//                       <button
//                         className="btn btn-success w-100 btn-lg"
//                         onClick={handlePayment}
//                         disabled={isProcessing}
//                       >
//                         {isProcessing ? (
//                           <>
//                             <span className="spinner-border spinner-border-sm me-2" />
//                             Processing...
//                           </>
//                         ) : (
//                           <>
//                             <RiCheckboxCircleLine className="me-2" />
//                             Pay {formatCurrency(totalAmount)}
//                           </>
//                         )}
//                       </button>

//                       {/* Security Info */}
//                       <div className="mt-3 text-center">
//                         <div className="small text-muted mb-2">
//                           <RiShieldLine className="me-1" />
//                           100% Secure Payment
//                         </div>
//                         <div className="alert alert-info small mb-0">
//                           <RiTimeLine className="me-1" />
//                           Your seats will be confirmed immediately after payment
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* CSS Styles */}
//       <style jsx>{`
//         .info-item {
//           display: flex;
//           align-items: center;
//           margin-bottom: 15px;
//         }

//         .point-details {
//           padding: 15px;
//           background: #f8f9fa;
//           border-radius: 8px;
//         }

//         .amount-summary {
//           background: #f8f9fa;
//           padding: 20px;
//           border-radius: 10px;
//         }

//         @media (max-width: 768px) {
//           .sticky-top {
//             position: static !important;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default CompletePayment;
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../Common/Configurations/AuthContext";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import {
  RiArrowLeftLine,
  RiMoneyRupeeCircleLine,
  RiCheckboxCircleLine,
  RiErrorWarningLine,
  RiTimeLine,
  RiShieldLine,
  RiLockUnlockLine,
  RiBusLine,
  RiMapPinLine,
  RiUserLine,
  RiCalendarLine,
} from "react-icons/ri";
import "./CompletePayment.css";

const CompletePayment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const {
    bookingId,
    bookingNo,
    bookTicketKey,
    bus,
    searchQuery,
    selectedSeats = [],
    passengerCount = 0,
    passengerDetails = [],
    selectedBoardingPoint,
    selectedDroppingPoint,
    totalAmount = 0,
    baseFare = 0,
    convenienceFee = 0,
  } = location.state || {};

  const [isProcessing, setIsProcessing] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("RAZORPAY");

  // Redirect if no booking data
  if (!bookingId || !bookTicketKey) {
    navigate("/bus/blocked-bookings");
    return null;
  }

  const formatCurrency = (amount) => {
    const num = parseFloat(amount) || 0;
    return `₹${Math.round(num).toLocaleString("en-IN")}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, "0");
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    } catch (error) {
      return dateString;
    }
  };

  const handlePayment = async () => {
    setIsProcessing(true);

    try {
      // Load Razorpay script
      const res = await loadRazorpayScript();
      if (!res) {
        alert("Razorpay SDK failed to load. Are you online?");
        return;
      }

      // Create payment order
      const paymentResult = await apiService.post(
        `${config.MAKEPAYMENT}?Amount=${totalAmount}&PayRequest=${paymentMethod}&CompanyId=${user?.cid}`
      );

      if (!paymentResult.succeeded) {
        alert("Payment initiation failed. Please try again.");
        return;
      }

      const { id: order_id, currency, razorpayKey, name } = paymentResult.data;

      const options = {
        key: razorpayKey,
        amount: totalAmount * 100,
        currency: currency,
        name: name,
        description: `Complete Blocked Booking - ${bus?.operatorName}`,
        order_id: order_id,
        handler: async function (paymentResponse) {
          try {
            // Call BlockAndBook API to confirm blocked booking
            const confirmResponse = await apiService.post(
              config.CONFIRMBLOCKEDBOOKING,
              {
                blockTicketKey: bookTicketKey,
                paymentResponse: paymentResponse,
                CompanyId: user?.cid,
                UserId: user?.id,
                PaymentStatus: "SUCCESS",
                PaymentGateway: paymentMethod,
              }
            );

            if (confirmResponse && confirmResponse.apiStatus?.success) {
              // Navigate to confirmation
              navigate("/bus/booking-confirmation", {
                state: {
                  bookingStatus: "CONFIRMED",
                  bookingId: confirmResponse.bookingId,
                  bookingNo: confirmResponse.bookingNo,
                  pnr: confirmResponse.pnr,
                  supplierBookingId: confirmResponse.supplierBookingId,
                  invoiceNo: confirmResponse.invoiceNo,
                  bookTicketKey: confirmResponse.bookTicketKey,
                  saleInvoiceNumber: confirmResponse.saleInvoiceNumber,
                  purchaseInvoiceNumber: confirmResponse.purchaseInvoiceNumber,
                  paymentId: paymentResponse.razorpay_payment_id,
                  orderId: paymentResponse.razorpay_order_id,
                  message: "Booking confirmed successfully!",
                  bus,
                  searchQuery,
                  selectedSeats,
                  passengerCount,
                  passengerDetails,
                  selectedBoardingPoint,
                  selectedDroppingPoint,
                  totalAmount,
                  baseFare,
                  convenienceFee,
                },
              });
            } else {
              alert(
                `Confirmation failed: ${confirmResponse?.apiStatus?.message}`
              );
              setIsProcessing(false);
            }
          } catch (error) {
            console.error("Confirmation error:", error);
            alert("Confirmation failed. Please contact support.");
            setIsProcessing(false);
          }
        },
        prefill: {
          email: user?.email,
          contact: user?.phoneNumber,
          name: user?.name,
        },
        theme: {
          color: "#3399cc",
        },
      };

      const paymentObject = new window.Razorpay(options);

      paymentObject.on("payment.failed", function (response) {
        console.error("Payment failed:", response.error);
        setIsProcessing(false);
        alert(`Payment failed: ${response.error.description}`);
      });

      paymentObject.on("payment.cancel", function (response) {
        console.log("Payment cancelled by user:", response);
        setIsProcessing(false);
        alert("Payment was cancelled.");
      });

      paymentObject.open();
    } catch (error) {
      console.error("Payment error:", error);
      alert("Payment initiation failed. Please try again.");
      setIsProcessing(false);
    }
  };

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) {
        resolve(true);
        return;
      }

      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handleBack = () => {
    navigate("/bus/blocked-bookings");
  };

  return (
    <div id="layout-wrapper">
      <Header />

      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            {/* Page Header */}
            <div className="row mb-4">
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center cp-flex-between">
                  <div>
                    <h3 className="mb-1">Complete Payment</h3>
                    <p className="text-muted mb-0">
                      Confirm your blocked seats by completing payment
                    </p>
                  </div>
                  <button
                    className="btn btn-outline-secondary cp-back-btn"
                    onClick={handleBack}
                  >
                    <RiArrowLeftLine className="me-1" />
                    Back
                  </button>
                </div>
              </div>
            </div>

            <div className="row">
              {/* Left Column - Booking Details */}
              <div className="col-lg-8">
                {/* Booking Info Card */}
                <div className="card border-warning cp-card cp-border-warning mb-4">
                  <div className="card-header bg-warning text-white cp-card-header cp-bg-warning">
                    <h5 className="mb-0">
                      <RiTimeLine className="me-2" />
                      Blocked Booking Details
                    </h5>
                  </div>
                  <div className="card-body cp-card-body">
                    <div className="alert alert-info cp-alert cp-alert-info">
                      <RiShieldLine className="me-2" />
                      <strong>Block Ticket Key:</strong> {bookTicketKey}
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="cp-info-item cp-mb-3">
                          <RiBusLine className="cp-text-muted me-2" />
                          <div>
                            <small className="cp-text-muted">Route</small>
                            <p className="mb-0 cp-fw-semibold">
                              {bus?.sourceCity} → {bus?.destinationCity}
                            </p>
                          </div>
                        </div>
                        <div className="cp-info-item cp-mb-3">
                          <RiCalendarLine className="cp-text-muted me-2" />
                          <div>
                            <small className="cp-text-muted">Travel Date</small>
                            <p className="mb-0 cp-fw-semibold">
                              {formatDate(searchQuery?.travelDate)}
                            </p>
                          </div>
                        </div>
                        <div className="cp-info-item">
                          <RiUserLine className="cp-text-muted me-2" />
                          <div>
                            <small className="cp-text-muted">Passengers</small>
                            <p className="mb-0 cp-fw-semibold">
                              {passengerCount} Passenger(s)
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="cp-info-item cp-mb-3">
                          <RiMapPinLine className="cp-text-muted me-2" />
                          <div>
                            <small className="cp-text-muted">Operator</small>
                            <p className="mb-0 cp-fw-semibold">
                              {bus?.operatorName}
                            </p>
                          </div>
                        </div>
                        <div className="cp-info-item cp-mb-3">
                          <RiMapPinLine className="cp-text-muted me-2" />
                          <div>
                            <small className="cp-text-muted">Bus Type</small>
                            <p className="mb-0 cp-fw-semibold">
                              {bus?.busType || "Standard"}
                            </p>
                          </div>
                        </div>
                        <div className="cp-info-item">
                          <div>
                            <small className="cp-text-muted">
                              Booking Reference
                            </small>
                            <p className="mb-0 cp-fw-semibold">{bookingNo}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Time Warning */}
                    <div className="alert alert-warning cp-alert cp-alert-warning mt-3">
                      <RiTimeLine className="me-2" />
                      <strong>Time Sensitive:</strong> Complete payment to
                      confirm your seats. Blocked seats will be released if not
                      confirmed.
                    </div>
                  </div>
                </div>

                {/* Boarding Points */}
                {(selectedBoardingPoint || selectedDroppingPoint) && (
                  <div className="card cp-card mb-4">
                    <div className="card-header bg-light cp-card-header">
                      <h5 className="mb-0">Boarding & Dropping Points</h5>
                    </div>
                    <div className="card-body cp-card-body">
                      <div className="row">
                        {selectedBoardingPoint && (
                          <div className="col-md-6">
                            <div className="cp-point-details">
                              <h6 className="cp-text-primary">
                                Boarding Point
                              </h6>
                              <p className="mb-1">
                                <strong>
                                  {selectedBoardingPoint.location}
                                </strong>
                              </p>
                              <p className="cp-text-muted mb-0">
                                Time: {selectedBoardingPoint.time}
                              </p>
                            </div>
                          </div>
                        )}
                        {selectedDroppingPoint && (
                          <div className="col-md-6">
                            <div className="cp-point-details">
                              <h6 className="cp-text-success">
                                Dropping Point
                              </h6>
                              <p className="mb-1">
                                <strong>
                                  {selectedDroppingPoint.location}
                                </strong>
                              </p>
                              <p className="cp-text-muted mb-0">
                                Time: {selectedDroppingPoint.time}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Right Column - Payment */}
              <div className="col-lg-4">
                <div className="cp-sticky-sidebar" style={{ top: "20px" }}>
                  {/* Payment Card */}
                  <div className="card border-success cp-card cp-border-success">
                    <div className="card-header bg-success text-white cp-card-header cp-bg-success">
                      <h5 className="mb-0">
                        <RiLockUnlockLine className="me-2" />
                        Complete Payment
                      </h5>
                    </div>
                    <div className="card-body cp-card-body">
                      {/* Amount Summary */}
                      <div className="cp-amount-summary cp-mb-4">
                        <div className="cp-amount-line cp-mb-2">
                          <div>
                            <span>Bus Fare</span>
                            <small className="cp-text-muted d-block">
                              Includes all taxes
                            </small>
                          </div>
                          <span>{formatCurrency(baseFare)}</span>
                        </div>

                        <div className="cp-amount-line cp-mb-2">
                          <div>
                            <span>Convenience Fee</span>
                            <small className="cp-text-muted d-block">
                              ₹100 per seat
                            </small>
                          </div>
                          <span>{formatCurrency(convenienceFee)}</span>
                        </div>

                        <div className="cp-amount-divider"></div>

                        <div className="cp-amount-total">
                          <strong>Total Amount</strong>
                          <strong className="cp-text-success fs-5">
                            {formatCurrency(totalAmount)}
                          </strong>
                        </div>
                      </div>

                      {/* Payment Method */}
                      <div className="cp-payment-method cp-mb-4">
                        <label className="cp-form-label">Payment Method</label>
                        <select
                          className="cp-form-select"
                          value={paymentMethod}
                          onChange={(e) => setPaymentMethod(e.target.value)}
                        >
                          <option value="RAZORPAY">
                            Razorpay (Cards, UPI, Net Banking)
                          </option>
                          <option value="WALLET">Wallet Balance</option>
                        </select>
                      </div>

                      {/* Action Button */}
                      <button
                        className="cp-action-btn cp-btn-success w-100 btn-lg"
                        onClick={handlePayment}
                        disabled={isProcessing}
                      >
                        {isProcessing ? (
                          <>
                            <span className="cp-spinner"></span>
                            Processing...
                          </>
                        ) : (
                          <>
                            <RiCheckboxCircleLine className="me-2" />
                            Pay {formatCurrency(totalAmount)}
                          </>
                        )}
                      </button>

                      {/* Security Info */}
                      <div className="cp-security-info">
                        <div className="cp-secure-payment">
                          <RiShieldLine className="me-1" />
                          100% Secure Payment
                        </div>
                        <div className="cp-note-alert cp-info">
                          <RiTimeLine className="me-1" />
                          Your seats will be confirmed immediately after payment
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompletePayment;
